import { IonFabButton } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Button = styled(IonFabButton)`
  border-radius: 50%;
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --color: ${myPalette.limeGreen['600']};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`
